import { Attr, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Influencer from "./Influencer";
import type InfluencersTopic from "./InfluencersTopic";
import type Outlet from "./Outlet";
import type OutletsTopic from "./OutletsTopic";

@Model()
class OutreachTopic extends ApplicationRecord {
  static jsonapiType = "outreach_topics";

  @HasMany() influencers: Influencer[];

  @HasMany({ name: "influencers_topics" })
  influencersTopics: InfluencersTopic[];

  @Attr() name: string;

  @HasMany() outlets: Outlet[];

  @HasMany({ name: "outletTopics" }) outletTopics: OutletsTopic[];
}

export default OutreachTopic;
